import { Refrigeration } from './refrigeration';
import { ToolSettingMode } from './tool-setting-mode';
import { ToolStep } from './tool-step';
import { ToolCategory } from './tool-category';
import { CamToolSlim } from './cam-tool-slim';
import { ToolRebuildOption } from './tool-rebuild-option';

export class Tool {

  constructor(
    public hash?: string,
    public name?: string,
    public erp?: string,
    public breakCheck?: number,
    public refrigeration?: Refrigeration,
    public toolCategory?: ToolCategory,
    public toolRebuildOption?: ToolRebuildOption,
    public stockNumber?: number,
    public toStoreCounter?: number,
    public inUseCounter?: number,
    public toRebuildCounter?: number,
    public toValidateCounter?: number,
    public toErpCounter?: number,
    public toolSettingModes?: ToolSettingMode[],
    public toolSteps?: ToolStep[],
    public refrigerationName?: string,
    public toolCategoryName?: string,
    public camTools?: CamToolSlim[],
    public toolRebuildOptions?: ToolRebuildOption[],
    public probeMovement?: number
  ) { }

  clone() {
    return new Tool (
      this.hash,
      this.name,
      this.erp,
      this.breakCheck,
      this.refrigeration,
      this.toolCategory,
      this.toolRebuildOption,
      this.stockNumber,
      this.toStoreCounter,
      this.inUseCounter,
      this.toRebuildCounter,
      this.toValidateCounter,
      this.toErpCounter,
      this.toolSettingModes,
      this.toolSteps,
      this.refrigerationName,
      this.toolCategoryName,
      this.camTools,
      this.toolRebuildOptions,
      this.probeMovement
    );
  }

  get filterableData() {
    return `${ this.toolCategoryName } ${ this.name } ${ this.erp }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool.ts